export default __webpack_public_path__ + "7dab92b5d212b54c9fbf8e4e0115c3b8.png";